// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__10-Mc","point":"Switch_point__YVjRy"};